import { z } from "zod";

export const TradingNameModelSchema = z.object({
  name: z.string().nullable(),
});

export const IndustryClassificationModel = z.object({
  uniqueIdentifier: z.string().nullable(),
  classificationCode: z.string().nullable(),
  classificationDescription: z.string().nullable(),
});

export const BusinessModelSchema = z.object({
  nzbn: z.string().nullable(),
  entityName: z.string().nullable(),
  entityTypeCode: z.string().nullable(),
  tradingNames: z.array(TradingNameModelSchema),
  industryClassifications: z.array(IndustryClassificationModel),
  registrationDate: z.coerce.date().nullable(),
  sourceRegisterUniqueIdentifier: z.string().nullable(),
});
